<template>
  <div
    class="form-error"
    :id="'error-' + id"
    :aria-hidden="validations.find(o => o.condition) ? 'false' : 'true'"
    :style="wrapperStyle"
  >
    <span
      v-for="(validation, index) in validations.filter(o => o.condition)"
      :key="index"
      data-testid="errorMessage"
      :style="validation.style"
    >
      {{ validation.text }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    validations: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => {}
    }
  }
}
</script>
